import './BlogHeader.css';

const BlogHeader = () => {
  return (
    <section className="blog-header">
      <h2 className="blog-header-title">
        Stay Updated with Low Brokerage Trading Platform
      </h2>
      <p className="blog-header-subtitle">
        Your Latest Market Insights Here
      </p>
    </section>
  );
};

export default BlogHeader;
